import {ChangeDetectionStrategy, Component} from "@angular/core";
import {BaseBadgeDirective} from "../../../shared";

@Component({
  selector: 'int-bordered-badge, [intBorderedBadge]',
  template: `<ng-content></ng-content>`,
  styleUrls: [
    '../../../shared/base-badge/base-badge.scss',
    './int-bordered-badge.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntBorderedBadgeComponent extends BaseBadgeDirective {}
